<div class="spacing-control">

    <!-- Linked Mode (2 inputs) -->
    <div *ngIf="!isIndividual" class="spacing-row">
        <div class="spacing-input">
            <i class="spacing-icon wms wms-horizontal-spacing" [title]="'Horizontal '+ property"></i>
            <input type="text" class="form-control" [value]="horizontalDisplay" [attr.data-identifier]="'property-'+property+'horizontal'"
                ng-model-options="{updateOn: 'blur change'}" (change)="updateAxisValues($event, 'horizontal')"
                (focus)="setActiveProperty(property)" placeholder="Horizontal" />
        </div>
        <div class="spacing-input">
            <i class="spacing-icon wms wms-vertical-spacing" [title]="'Vertical '+ property"></i>
            <input type="text" class="form-control" [value]="verticalDisplay" [attr.data-identifier]="'property-'+property+'vertical'"
                ng-model-options="{updateOn: 'blur change'}" (change)="updateAxisValues($event, 'vertical')"
                (focus)="setActiveProperty(property)" placeholder="Vertical" />
        </div>
    </div>

    <!-- individual Mode (4 inputs) -->
    <div *ngIf="isIndividual" class="spacing-grid">
        <div class="spacing-input">
            <i class="spacing-icon wms wms-left-spacing" [title]="'Left '+ property"></i>
            <input type="number" class="form-control" [(ngModel)]="spacing.left" [attr.data-identifier]="'property-'+property+'left'"
                ng-model-options="{updateOn: 'blur change'}" (focus)="setActiveProperty(property)"
                (change)="onSpacingingChange('left')" placeholder="Left" />
        </div>
        <div class="spacing-input">
            <i class="spacing-icon wms wms-top-spacing" [title]="'Top '+ property"></i>
            <input type="number" class="form-control" [(ngModel)]="spacing.top" [attr.data-identifier]="'property-'+property+'top'"
                ng-model-options="{updateOn: 'blur change'}" (focus)="setActiveProperty(property)"
                (change)="onSpacingingChange('top')" placeholder="Top" />
        </div>
        <div class="spacing-input">
            <i class="spacing-icon wms wms-right-spacing" [title]="'Right '+ property"></i>
            <input type="number" class="form-control" [(ngModel)]="spacing.right" [attr.data-identifier]="'property-'+property+'right'"
                ng-model-options="{updateOn: 'blur change'}" (focus)="setActiveProperty(property)"
                (change)="onSpacingingChange('right')" placeholder="Right" />
        </div>
        <div class="spacing-input">
            <i class="spacing-icon wms wms-bottom-spacing" [title]="'Bottom '+ property"></i>
            <input type="number" class="form-control" [(ngModel)]="spacing.bottom" [attr.data-identifier]="'property-'+property+'bottom'"
                ng-model-options="{updateOn: 'blur change'}" (focus)="setActiveProperty(property)"
                (change)="onSpacingingChange('bottom')" placeholder="Bottom" />
        </div>

    </div>
    <i class="spacing-toggle-icon wms wms-individual-spacing" [title]="'Individual '+ property" [ngClass]="{'isIndividual': isIndividual}" [attr.data-identifier]="'property-'+property+'individual'"
        (click)="toggleLink()"></i>
</div>